import React from 'react';
import { useNavigate } from 'react-router-dom';
import './GoldLanding.css'; 

const GoldLanding = () => {
  const navigate = useNavigate();

  return (
    <div className="gold-landing">
      <header className="gold-header">
        <h1>Welcome to DiscountDost Gold</h1>
        <button className="gold-login-btn" onClick={() => navigate('/login?from=gold')}>
            <span role="img" aria-label="account" style={{ marginRight: '6px' }}>👤</span>
            Login
        </button>
      </header>

      {/* Section 1 - Hero Banner */}
      <div className="hero-highlight">
        <h2>Buy 24K Gold in 24 Seconds.</h2>
        <p>10,544 transactions in the last 1 hour.</p>
        <p>Start investing in gold starting as low as ₹10</p>

        <div className="secured-info">
          <span>Secured by</span>
          <img src="/vistra-logo.png" alt="Vistra" /> {/* Add local logo or URL later */}
          <span>Gold corresponding to every purchase you make is stored in world-class vaults.</span>
        </div>
      </div>

      {/* Section 2 & 3 */}
      <div className="section-grid-2">
        {/* Left - Better than FD */}
        <div className="better-than-fd">
          <h3>Better than an FD</h3>
          <p>A ₹1000 investment 5 years ago would be:</p>
          <div className="compare-values">
            <div><strong>Gold</strong><br />₹1983</div>
            <div><strong>FD</strong><br />₹1384</div>
          </div>

          <div className="invest-card">
            <h4>Grow your wealth smarter</h4>
            <p>Start an SIP to invest in gold every month.</p>
            <button>Start Investing</button>
          </div>
        </div>

        {/* Right - Graph */}
        <div className="growth-graph">
          <h3>Show growth for:</h3>
          <div className="buttons">
            <button>1 Year</button>
            <button>2 Years</button>
            <button>5 Years</button>
          </div>
          <div className="graph-placeholder" style={{ marginTop: '20px' }}>
            {/* Placeholder */}
            <p style={{ textAlign: 'center', color: '#aaa' }}>Graph will be shown here</p>
          </div>
        </div>
      </div>

      {/* Section 4 - Why Go Digital */}
      <div className="why-digital">
        <h3>Why go digital?</h3>
        <div className="digital-grid">
          <div className="digital-card">
            <h4>Guaranteed 24K Gold</h4>
            <p>Unlike local vendors, with SafeGold, you directly buy from the manufacturer.</p>
          </div>
          <div className="digital-card">
            <h4>Sell anytime from home</h4>
            <p>Sell anytime, without going anywhere and receive money direct in your account.</p>
          </div>
          <div className="digital-card">
            <h4>Earn income on gold</h4>
            <p>You can lend digital gold to SafeGold-verified borrowers and earn monthly rental income in the form of gold.</p>
          </div>
          <div className="digital-card">
            <h4>Safety guaranteed</h4>
            <p>Unlike physical gold, you don’t have to worry about theft or expensive locker fees. You gold is stored in bank-grade lockers free of cost.</p>
          </div>
          <div className="digital-card">
            <h4>Convert to physical gold</h4>
            <p>You can convert your digital gold to physical gold anytime in the form of coins or jewellery through our partners.</p>
          </div>
          <div className="digital-card">
            <h4>Buy as low as ₹10</h4>
            <p>Digital does not require to invest a large sum of money. You can invest based on your budget.</p>
          </div>
        </div>
      </div>

      {/* Section 5 - Convert to Physical */}
      <div className="convert-section">
        <h3>Digital to physical in minutes</h3>
        <div className="convert-options">
          <div className="convert-box">
            <h4>Coins</h4>
            <img
              src="/coins-tab-img.png"
              alt="Gold Coins"
              style={{
                width: '100%',
                height: 'auto',
                borderRadius: '8px',
                marginBottom: '10px'
              }}
            />
            <p>24K Gold Coins & Bars delivered to your doorstep</p>
            <p>Convert your digital gold to physical gold by paying a nominal minting charge. Your delivery comes with free insurance, to ensure your coins and bars reach you safely.</p>
          </div>
          <div className="convert-box">
            <h4>Jewellery</h4>
            <p>CaratLane | Redeem Offline</p>
            <p>Redeem by sharing your SafeGold number at the CaratLane store. Verify using an OTP and pay using your SafeGold balance.</p>
          </div>
        </div>
      </div>

      <footer>
        <p>Powered by DiscountDost • SafeGold Partner</p>
      </footer>
    </div>
  );
};

export default GoldLanding;
